import React from "react";
import "./RoadmapCard.scss";

export default function RoadmapCard({ children, className = "" , ...rest }) {
    return (
        <div className={`roadmap-card-wrapper ${className}`} {...rest}>
            <div className="roadmap-card">
                <div className="solid-border"></div>
                <div className="gradient-border"></div>
                {children}
            </div>
        </div>
    );
}
